import request from '@/utils/request'

// The RBAC routes are mounted at the API root (`/rbac/...`), not under the
// `/api/v2` prefix that VUE_APP_BASE_API carries, so strip that suffix for
// these calls.
const rbacBaseURL = (process.env.VUE_APP_BASE_API || '').replace(/\/api\/v2\/?$/, '')

export interface RbacRole {
  roleKey: string
  name?: string
}

export interface MyRbac {
  userId: string
  roles: RbacRole[]
  permissions: string[]
  panelAccess: {
    hasAccess: boolean
    panels: string[]
  }
}

// Current user's real roles/permissions. This is the source of truth for panel
// authorization; the legacy users.user_type field is being retired.
export const getMyRbac = () =>
  request({
    url: '/rbac/me',
    method: 'get',
    baseURL: rbacBaseURL
  })
